export enum IconSeverityEnum {
    alert = ' do_not_disturb',
    warning = 'warning_amber',
    info = 'info',
    success = 'check_circle'
}
